import React, { useEffect, useState, useCallback } from "react";

const EditableItemProperty = ({ value, property, onChange, onSave }) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const placeholder = window.i18n.t(`source_menu.${property}`);

  const handleInputChange = useCallback((e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange(newValue);
  }, [onChange]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.blur();
      onSave();
    }

    if (e.key === "Escape") {
      e.preventDefault();
      e.currentTarget.blur();
    }
  }, [onSave]);

  const adjustTextareaHeight = (el) => {
    if (el.scrollHeight > el.offsetHeight) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  const handleFocus = useCallback((e) => {
    adjustTextareaHeight(e.currentTarget);
  }, []);

  const handleBlur = useCallback((e) => {
    e.currentTarget.style.height = "auto";
  }, []);

  return (
    <div className="palette-editable-container">
      <textarea
        className="palette-editable"
        rows={1}
        value={inputValue}
        placeholder={placeholder}
        onInput={handleInputChange}
        onKeyDown={handleKeyDown}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default EditableItemProperty;
